<template>
  <div class="grid-table" :class="device">
    <div class="heading">
      <span class="label">{{ $t('hose.recommended') }}</span>
      <span>{{ $t('hose.alert') }}</span>
    </div>
    <div class="grid-row header">
      <div class="grid-col-1 grid-col">
        <span class="text">{{ $t('hose.name') }}</span>
      </div>
      <div class="grid-col-3 grid-col">
        <img class="icon" :src="getImage('hose/measurement_dn.svg')">
        <span class="text">{{ $t('hose.measurement') }}</span>
      </div>
      <div class="grid-col-4 grid-col">
        <img class="icon" :src="getImage('hose/measurement_outer.svg')">
        <span class="text">{{ $t('hose.measurementOuter') }}</span>
      </div>
      <div class="grid-col-5 grid-col">
        <img class="icon" :src="getImage('hose/pressure.svg')">
        <span class="text">{{ $t('hose.pressure') }}</span>
      </div>
      <div class="grid-col-6 grid-col">
        <img class="icon" :src="getImage('hose/burst_pressure.svg')">
        <span class="text">{{ $t('hose.burstPressure') }}</span>
      </div>
      <div class="grid-col-7 grid-col">
        <img class="icon" :src="getImage('hose/bend_radius.svg')">
        <span class="text">{{ $t('hose.bendRadius') }}</span>
      </div>
      <div class="grid-col-8 grid-col">
        <img class="icon" :src="getImage('hose/kg_m.svg')">
        <span class="text">{{ $t('hose.kgM') }}</span>
      </div>
    </div>

    <grid-row-hoses
        v-for="hose in sortedHoses"
        :object="hose"
        :key="hose.id"
        v-model="selectedHose"
    >
    </grid-row-hoses>
  </div>
</template>

<script>
import GridRow from "@/components/hose/components/GridRowHoses";
import {mapGetters} from "vuex";
import GridRowHoses from "@/components/hose/components/GridRowHoses";

export default {
  name: "GridTable",

  props: {
    showAll: {
      type: Boolean,
      default: false
    }
  },

  components: {GridRowHoses, GridRow},

  computed: {
    ...mapGetters({
      hoses: "build/hoses/hoses/getAll",
      build: "build/hoses/getHoseBuild",
      preferences: "build/hoses/getHosePreferences",
      device: 'getDevice',
    }),
    selectedHose: {
      get() {
        return this.build.selectedHose;
      },
      set(val) {
        this.$store.commit('build/hoses/setSelectedHose', val);
        this.$store.dispatch('build/hoses/setFirstAvailableCoupling');
      },
    },
    sortedHoses() {
      let hoses = this.hoses;
      let pressure = this.preferences.pressure;
      let lpm = this.preferences.lpm;
      let application = this.preferences.application;

      if (this.showAll) {
        return hoses.filter(function (hose) {
          return hose.pressure >= pressure &&
              hose.flow_pressurehose >= lpm &&
              hose.type === application;
        });
      } else {
        return hoses.filter(function (hose) {
          return hose.pressure >= pressure &&
              hose.flow_pressurehose >= lpm &&
              hose.type === application;
        }).slice(0, 6);
      }
    }
  },
}
</script>

<style lang="scss">
.grid-table {
  display: flex;
  flex-direction: column;

  .heading {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-bottom: 20px;
    margin-right: 5px;
    font-family: neue-haas-grotesk-display, sans-serif;

    .label {
      margin-top: 28px;
      font-size: 14px;
    }
  }

  .grid-row {
    display: grid;
    grid-template-columns: repeat(8, 2fr) 3fr;
    background-color: #F5F5F5;
    font-size: 12px;
    align-items: flex-end;

    &.header {
      font-family: neue-haas-grotesk-display, sans-serif;
      margin-bottom: 4px;

      .grid-col {
        display: flex;
        align-items: center;
        flex-direction: column;
        border-left: 3px solid #F0F0F0;

        img {
          margin-bottom: 6px;
          width: 42px;
          height: 42px;
        }

        .text {
          text-align: center;
        }
      }
    }

    .grid-col-1 {
      grid-row: 1 / 2;
      grid-column: 1/3;
    }

    .grid-col-2 {
      grid-row: 1 / 2;
      grid-column: 2/3;
    }

    .grid-col-3 {
      grid-row: 1 / 2;
      grid-column: 3/4;
    }

    .grid-col-4 {
      grid-row: 1 / 2;
      grid-column: 4/5;
    }

    .grid-col-5 {
      grid-row: 1 / 2;
      grid-column: 5/6;
    }

    .grid-col-6 {
      grid-row: 1 / 2;
      grid-column: 6/7;
    }

    .grid-col-7 {
      grid-row: 1 / 2;
      grid-column: 7/8;
    }

    .grid-col-8 {
      grid-row: 1 / 2;
      grid-column: 8/9;
    }

    .grid-col-9 {
      grid-row: 1 / 2;
      grid-column: 9/10;
    }
  }

  &.mobile {
    min-width: 800px;
    overflow-y: scroll;

    .grid-row {
      grid-template-columns: 4fr repeat(8, 2fr) 3fr;
    }

    .grid-col-9 {
      grid-column: 9 / 11;
      grid-row: 1 / 2;
    }

    .heading {
      .label {
        display: block;
      }

      span {
        display: none;
      }
    }
  }
}
</style>